import { FC } from 'react'
import * as styles from 'styles/atoms/UserAgentBadge.css'
import { UserAgent, UserAgentBrowser, UserAgentOS } from 'interfaces/auth'

type UserAgentBadgeProps = UserAgent

const formatString = (obj: UserAgentOS | UserAgentBrowser): string => {
  const { family, major, minor, patch } = obj
  if (family === 'Other') {
    return 'Unknown'
  }

  const versionParts = [major, minor, patch].filter((v) => v !== null)
  const version = versionParts.length !== 0 ?
    ` ${ versionParts.join('.') }` :
    ''

  return `${ family }${ version }`
}

const UserAgentBadge: FC<UserAgentBadgeProps> = (props) => {
  const { browser, os } = props

  return (
    <div className={ styles.browserBadge } data-qa-type='user-agent-badge'>
      <div className={ styles.browser }>
        <span className={ styles.caption }>Browser:</span>
        <span className={ styles.value } data-qa-marker='user-agent-browser'>
          { formatString(browser) }
        </span>
      </div>
      <div className={ styles.os }>
        <span className={ styles.caption }>OS:</span>
        <span className={ styles.value } data-qa-marker='user-agent-os'>
          { formatString(os) }
        </span>
      </div>
    </div>
  )
}


export default UserAgentBadge
